<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" [title]="value">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
    }
    {{ label }}
  </mat-label>
  <input
    matInput
    [formControl]="inputControl"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [required]="isRequiredControl"
    [readonly]="isDisabled || isOwnTenant"
    [errorStateMatcher]="this"
    spellcheck="false"
    autocomplete="off"
    nimbusGUID
  />
  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>
  @if (isPermissionError) {
    <nimbus-mat-icon-overlay matSuffix [icon]="icons.EXCLAMATION_TRIANGLE">
      {{ TranslationKeys.AdminPermissionErrorConsentNeededWithClickableLink | translate }}
      <a [href]="consentLink" rel="noopener" target="_blank">link</a>.
    </nimbus-mat-icon-overlay>
  }
  <!-- One root element per @if: a block with several roots is not projected into the matSuffix slot. -->
  @if (isDisabled && showCopy && value) {
    <i
      matSuffix
      class="cursor-pointer"
      [nimbusIcon]="icons.COPY"
      [nimbusCopyClipboard]="value"
      [title]="TranslationKeys.GeneralCopy | translate"
    ></i>
  }
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }
  @if (!isDisabled && value) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }
  @if (groupViewModel) {
    <i matSuffix class="cursor-pointer always-enabled" [nimbusIcon]="icons.INFO_CIRCLE" (click)="onDetailsClick($event)"></i>
  }
  @if (isLoading) {
    <nimbus-spinner matSuffix [absolute]="false" [height]="8"></nimbus-spinner>
  }

  @if (isErrorState() && !isPermissionError) {
    <mat-error>
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }
  @if (warningMessage) {
    <mat-hint align="start"> <i [nimbusIcon]="icons.INFO_CIRCLE" class="error-triangle"></i>{{ warningMessage }} </mat-hint>
  }
</mat-form-field>
